.onClassActive,
.onDataHighlighted,
.onFocus {
  transition: outline 300ms var(--ease);
}

.none,
.onClassActive,
.onDataHighlighted,
.onFocus,
.onFocus:focus {
  outline: solid 8px transparent;
}

.onClassActive.active,
.onDataHighlighted[data-highlighted],
.onFocus:focus-visible {
  outline: solid 2px var(--color-rose);
}
